import axios from "axios";

const state = {
    stock_state: {
        symbol: {
            data: {
                "isin": "IRO3IKDP0001",
                "short_isin": "IKDP1",
                "short_name": "خاور   ",
                "long_name": "ايران خودرو ديزل",
                "english_name": "IranKhodro Diesel",
                "company_isin": "IRO3IKDP0004",
                "company_short_isin": "IKDP",
                "company_name": "ايران خودرو ديزل",
                "market_code": "1",
                "market_name": "بازار اول فرابورس",
                "group_code": "34 ",
                "group_name": "خودرو و ساخت قطعات",
                "subgroup_code": "3410",
                "subgroup_name": "توليد وسايل نقليه موتوري",
                "last": 3534,
                "close": 3631,
                "open": 3693,
                "yesterday": 3657,
                "high": 3750,
                "low": 3530,
                "count": 4083,
                "volume": 85345563,
                "value": 309851092930,
                "last_state": 'مجاز'
            },
            count: 0
        },
        symbol_orders: [],
        orders: [
            {
                "ticker_symbol": "",
                "quantity": 0,
                "price": 0,
                "timestamp": "",
                "order_type": "BUY",
                "order_state": "APPROVED"
            },
        ],
        sybmol_list: {
            data: []
        },
        top_symbols: [],
        snapshots: [],
        daily_profits: [],
        weekly_profits: [],
        monthly_profits: [],
        portfolio: [],
        rankings: {
            daily: [],
            weekly: [],
            monthly: [],
        },
        loading: false
    }
}
const mutations = {
    success_get_top_symbols(state, payload) {
        state.stock_state.top_symbols = payload
    },
    // search symbol
    search_symbol_success(state, payload) {
        state.stock_state.sybmol_list = payload
    },
    get_symbol_detail_success(state, payload) {
        state.stock_state.symbol = payload
    },
    buy_stock_success(state, payload) {
        this.commit('show_snackbar', {
            text: "خرید سهام مورد نظر با موفقیت انجام شد.",
            type: 1,
        })
    },


    handle_buy_stock_error(state, error) {
        let error_status = error.response.status
        let error_text = "خطا در ارتباط با سامانه بورس."
        if (error_status === 406) {
            let error_code = error.response.data.error_code
            if (error_code === 0)
                error_text = 'برای خرید سهام باید در یک تیم باشید.'
            if (error_code === 1)
                error_text = "بازار خرید و فروش در حال حاضر بسته است."
            if (error_code === 2)
                error_text = "این نماد در حال حاضر در دسترس نمیباشد."
            if (error_code === 3)
                error_text = "قیمت پذیرفته نشد."
            if (error_code === 4)
                error_text = "عدم موجودی حساب"
            if (error_code === 5)
                error_text = "فروشنده ای سفارش شما را نپذیرفت."
        }
        this.commit('show_snackbar', {
            text: error_text,
            type: 2,
        })
    }
    ,
    get_orders_success(state, payload) {
        state.stock_state.orders = payload.data
    }
    ,
    get_portfolio_success(state, payload) {
        state.stock_state.portfolio = payload
    }
    ,
    handle_sell_stock_error(state, error) {
        let error_status = error.response.status
        let error_text = "خطا در ارتباط با سامانه بورس."
        if (error_status === 406) {
            let error_code = error.response.data.error_code
            if (error_code === 0)
                error_text = 'برای خرید سهام باید در یک تیم باشید.'
            if (error_code === 1)
                error_text = "بازار خرید و فروش در حال حاضر بسته است."
            if (error_code === 2)
                error_text = "این نماد در حال حاضر در دسترس نمیباشد."
            if (error_code === 3)
                error_text = "قیمت پذیرفته نشد."
            if (error_code === 4)
                error_text = "دارایی تیم شما برای این فروش کافی نیست."
            if (error_code === 5)
                error_text = "فروش شما تایید نشد."
        }
        this.commit('show_snackbar', {
            text: error_text,
            type: 2,
        })
    }
    ,

    sell_stock_success(state, payload) {
        this.commit('show_snackbar', {
            text: 'سهام با موفقیت فروخته شد.',
            type: 1,
        })
    }
    ,
    get_symbol_orders_success(state, response) {
        state.stock_state.symbol_orders = response
    }
    ,
    get_snapshots_success(state, response) {
        state.stock_state.snapshots = response
    }
    ,
    get_daily_profit_success(state, response) {
        state.stock_state.daily_profits = response
    },
    get_weekly_profit_success(state, response) {
        state.stock_state.weekly_profits = response
    },
    get_monthly_profit_success(state, response) {
        state.stock_state.monthly_profits = response
    },
    get_weekly_ranking_success(state, response) {
        state.stock_state.rankings.weekly = response
    },
    get_daily_ranking_success(state, response) {
        state.stock_state.rankings.daily = response
    },
    get_monthly_ranking_success(state, response) {
        state.stock_state.rankings.monthly = response
    },


}
const actions = {
    //search symbol
    get_top_symbols({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'market/top-symbols/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('success_get_top_symbols', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در دریافت پربازدیدترین نمادها', type: 2})
                    reject(err)
                });
        })
    },
    search_symbol({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'market/search/' + encodeURIComponent(payload.search_query) + '/',
            };
            axios(config)
                .then(function (response) {
                    commit('search_symbol_success', response)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    get_symbol_detail({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'market/details/' + payload.id + '/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('get_symbol_detail_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    buy_stock({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'post',
                url: this.state.base_api + 'market/buy/',
                data: payload,
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('buy_stock_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('handle_buy_stock_error', err)
                    reject(err)
                });
        })
    },
    sell_stock({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'post',
                url: this.state.base_api + 'market/sell/',
                data: payload,
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('sell_stock_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                        commit('handle_sell_stock_error', err)
                        reject(err)
                    }
                );
        })
    },
    get_orders({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'market/orders/',
                data: payload,
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('get_orders_success', response)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    get_portfolio({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'market/portfolio/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('get_portfolio_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    get_symbol_orders({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'market/symbol-orders/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },
                params: {
                    symbol_id: payload.id
                }
            };
            axios(config)
                .then(function (response) {
                    commit('get_symbol_orders_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    get_team_snapshots({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'reports/snapshots/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('get_snapshots_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    get_daily_profits({commit}, payload) {
        let range = payload.range
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'reports/profits/daily?' + 'end=' + range[0] + '&start=' + range[1],
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('get_daily_profit_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    get_weekly_profits({commit}, payload) {
        let values = payload.month.split('-')
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'reports/profits/weekly?' + 'month=' + values[1] + '&year='+values[0],
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('get_weekly_profit_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    get_monthly_profits({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'reports/profits/monthly?' + 'year=' + payload.year,
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('get_monthly_profit_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    get_ranking_daily({commit}, payload) {
        let values = payload.date.split('-')
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'reports/ranking/daily-profits?' + 'month=' + values[1] + '&year='+values[0]+ '&day='+values[2],
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('get_daily_ranking_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    get_ranking_weekly({commit}, payload) {
        let values = payload.date.split('-')

        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'reports/ranking/weekly-profits/?' + 'month=' + values[1] + '&year='+values[0]+ '&day='+values[2],
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('get_weekly_ranking_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    get_ranking_monthly({commit}, payload) {
        let values = payload.month.split('/')
        console.log(values,'monthly profits of this year')
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'reports/ranking/monthly-profits?' + 'month=' + values[1] + '&year='+values[0],
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('get_monthly_ranking_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
}
export default {
    state,
    mutations,
    actions

}